import * as React from 'react';
import FormGroup, { FormGroupProps } from '@material-ui/core/FormGroup';

export type DSFormGroupProps = FormGroupProps;

export function DSFormGroup(props: DSFormGroupProps): JSX.Element {
    return <FormGroup {...props} />;
}
